const API_BASE = import.meta.env.VITE_API_BASE ?? '';

function detectDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk|(android(?!.*mobile))/i.test(ua)) return 'tablet';
  if (/mobile|android|iphone|ipod|blackberry|opera mini|iemobile/i.test(ua)) return 'mobile';
  return 'desktop';
}

/**
 * Registra una ejecución de test (completada o abandonada).
 * Fire-and-forget: no bloquea la UI ni propaga errores.
 */
export function registrarUso({ tipo_test, test_id, tarea_id, nombre_test = '', completada, total_items = 0, correctas = 0, errores = 0 }) {
  fetch(`${API_BASE}/api/uso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      tipo_test,
      test_id:     Number(test_id),
      tarea_id:    Number(tarea_id),
      nombre_test: String(nombre_test),
      completada:  Boolean(completada),
      total_items: Number(total_items),
      correctas:   Number(correctas),
      errores:     Number(errores),
      device_type: detectDevice(),
    }),
  }).catch(() => {});
}
